// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-container {
  padding: 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.history-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #000;
}

.loading {
  text-align: center;
  padding: 60px;
  font-size: 18px;
  color: #666;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.history-table thead {
  background: var(--button-color);
  color: #fff;
}

.history-table th {
  padding: 16px;
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-right: 1px solid var(--hover-color);
}

.history-table th:last-child {
  border-right: none;
}

.history-table th:hover {
  background: var(--hover-color);
}

.history-table tbody tr:nth-child(odd) {
  background: #fff;
}

.history-table tbody tr:nth-child(even) {
  background: var(--background-color);
}

.history-table tbody tr:hover {
  background: #e8e8e8;
}

.history-table td {
  padding: 16px;
  font-size: 14px;
  color: #000;
  border-right: 1px solid var(--button-color);
}

.history-table td:last-child {
  border-right: none;
}

/* LAKPED-13: filtro e indicador de comparativa guardada */
.comparison-filter {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  color: #444;
  -webkit-user-select: none;
          user-select: none;
  transition: border-color 0.15s, color 0.15s;
}

.comparison-filter:hover {
  border-color: var(--button-color);
  color: var(--button-color);
}

.comparison-filter input {
  cursor: pointer;
  margin: 0;
  accent-color: var(--button-color);
}

/* Celda del análisis: nombre arriba, acciones debajo y alineadas entre sí */
.analysis-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.analysis-name {
  color: #333;
}

.analysis-links {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.btn-link {
  background: transparent;
  border: none;
  color: var(--button-color);
  cursor: pointer;
  font-size: 13px;
  padding: 0;
  text-decoration: none;
}

.btn-link:hover {
  color: var(--hover-color);
  text-decoration: underline;
}

/* Dato secundario bajo el nombre del plano: no roba ancho a la columna */
.plano-nombre {
  color: #222;
}

.plano-comparativa {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 5px;
  padding: 0;
  background: transparent;
  border: none;
  color: #6b6b6b;
  cursor: pointer;
  font-size: 12px;
  transition: color 0.15s ease;
}

.plano-comparativa:hover {
  color: var(--button-color);
  text-decoration: underline;
}

.btn-download {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  color: var(--button-color);
}

.btn-download:hover {
  opacity: 0.7;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-pending {
  background: #fef3c7;
  color: #92400e;
}

.status-processing {
  background: #dbeafe;
  color: #1e40af;
  animation: pulse 2s infinite;
}

.status-completed {
  background: #d1fae5;
  color: #065f46;
}

.status-failed {
  background: #fee2e2;
  color: #991b1b;
}

.status-skipped {
  background: #ffedd5;
  color: #c2410c;
}

.status-invoice {
  background: #d1fae5;
  color: #065f46;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.btn-delete {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  color: #000;
}

.btn-delete:hover {
  opacity: 0.7;
}

.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}

.pagination-info {
  font-size: 14px;
  color: #666;
}

.pagination-controls {
  display: flex;
  gap: 20px;
  align-items: center;
}

.pagination-page {
  font-size: 14px;
  color: #000;
  font-weight: 500;
}

/* Buscador + filtro en una sola barra */
.history-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.history-container .history-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 300px;
  max-width: 420px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  color: #999;
  transition: border-color 0.15s ease;
}

.history-container .history-search:focus-within {
  border-color: var(--button-color);
  color: var(--button-color);
}

.history-container .history-search input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #000;
  background: transparent;
}

.history-container .history-search-clear {
  border: none;
  background: transparent;
  color: #999;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
}

.history-container .history-search-clear:hover { color: #333; }
`, "",{"version":3,"sources":["webpack://./src/components/History/HistoryTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iCAAiC;AACnC;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,iDAAiD,WAAW,EAAE","sourcesContent":[".history-container {\n  padding: 40px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.history-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 30px;\n  color: #000;\n}\n\n.loading {\n  text-align: center;\n  padding: 60px;\n  font-size: 18px;\n  color: #666;\n}\n\n.history-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.history-table thead {\n  background: var(--button-color);\n  color: #fff;\n}\n\n.history-table th {\n  padding: 16px;\n  text-align: left;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  user-select: none;\n  border-right: 1px solid var(--hover-color);\n}\n\n.history-table th:last-child {\n  border-right: none;\n}\n\n.history-table th:hover {\n  background: var(--hover-color);\n}\n\n.history-table tbody tr:nth-child(odd) {\n  background: #fff;\n}\n\n.history-table tbody tr:nth-child(even) {\n  background: var(--background-color);\n}\n\n.history-table tbody tr:hover {\n  background: #e8e8e8;\n}\n\n.history-table td {\n  padding: 16px;\n  font-size: 14px;\n  color: #000;\n  border-right: 1px solid var(--button-color);\n}\n\n.history-table td:last-child {\n  border-right: none;\n}\n\n/* LAKPED-13: filtro e indicador de comparativa guardada */\n.comparison-filter {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  border: 1px solid #e0e0e0;\n  border-radius: 20px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  color: #444;\n  user-select: none;\n  transition: border-color 0.15s, color 0.15s;\n}\n\n.comparison-filter:hover {\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\n.comparison-filter input {\n  cursor: pointer;\n  margin: 0;\n  accent-color: var(--button-color);\n}\n\n/* Celda del análisis: nombre arriba, acciones debajo y alineadas entre sí */\n.analysis-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.analysis-name {\n  color: #333;\n}\n\n.analysis-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.btn-link {\n  background: transparent;\n  border: none;\n  color: var(--button-color);\n  cursor: pointer;\n  font-size: 13px;\n  padding: 0;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  color: var(--hover-color);\n  text-decoration: underline;\n}\n\n/* Dato secundario bajo el nombre del plano: no roba ancho a la columna */\n.plano-nombre {\n  color: #222;\n}\n\n.plano-comparativa {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 5px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: #6b6b6b;\n  cursor: pointer;\n  font-size: 12px;\n  transition: color 0.15s ease;\n}\n\n.plano-comparativa:hover {\n  color: var(--button-color);\n  text-decoration: underline;\n}\n\n.btn-download {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  color: var(--button-color);\n}\n\n.btn-download:hover {\n  opacity: 0.7;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-processing {\n  background: #dbeafe;\n  color: #1e40af;\n  animation: pulse 2s infinite;\n}\n\n.status-completed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-skipped {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.status-invoice {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.btn-delete {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  color: #000;\n}\n\n.btn-delete:hover {\n  opacity: 0.7;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 30px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.pagination-info {\n  font-size: 14px;\n  color: #666;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.pagination-page {\n  font-size: 14px;\n  color: #000;\n  font-weight: 500;\n}\n\n/* Buscador + filtro en una sola barra */\n.history-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.history-container .history-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 300px;\n  max-width: 420px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  color: #999;\n  transition: border-color 0.15s ease;\n}\n\n.history-container .history-search:focus-within {\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\n.history-container .history-search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  color: #000;\n  background: transparent;\n}\n\n.history-container .history-search-clear {\n  border: none;\n  background: transparent;\n  color: #999;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.history-container .history-search-clear:hover { color: #333; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
